import { render, staticRenderFns } from "./the-blog.vue?vue&type=template&id=725a8792"
import script from "./the-blog.vue?vue&type=script&lang=js"
export * from "./the-blog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PostList: require('/opt/build/repo/components/post/List.vue').default,BlogLayout: require('/opt/build/repo/components/blog/Layout.vue').default,LayoutBanner: require('/opt/build/repo/components/layout/Banner.vue').default})
